import React from "react";
import DatePickerInner from "./DatePickerInner";
import moment from "moment";

export default class MyDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: new Date(),
    };
  }

  componentDidMount() {
    // Se hai una prop "selected" (o "value") che imposta il valore iniziale, usala qui
    if (this.props.selected) {
      this.setState({ value: this.props.selected });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.setState({ value: this.props.selected });
    }
  }

  getDate() {
    return this.state.value;
  }

  render() {
    return (
      <div style={mainClass}>
        <div style={name}>{this.props.name}</div>
        <DatePickerInner
          readOnly={this.props.readOnly || false}
          style={inputText}
          selected={this.state.value}
          dateFormat={this.props.dateFormat || "dd-MM-yyyy"}
          onChange={(date) => {
            this.setState({ value: date });
            // Invoca la callback del padre, passando l'oggetto Date selezionato
            if (this.props.onChange) {
              this.props.onChange(date);
            }
          }}
        />
      </div>
    );
  }
}

const mainClass = {
  padding: "5px",
};

const name = {};

const inputText = {
  width: "300px",
  padding: "10px",
};
